
import React from 'react';
import { CaregiverProfile } from '../../../types/index';

interface AboutTabProps {
  profile: Pick<CaregiverProfile, 'about' | 'experience' | 'languages' | 'specialties' | 'certifications'>;
}

const AboutTab: React.FC<AboutTabProps> = ({ profile }) => {
  return (
    <div className="d-flex flex-column gap-5">
      <section>
        <h2 className="h5 fw-bold text-dark mb-3">About Me</h2>
        {/* Render HTML content securely assuming trusted source, or sanitize in production */}
        <div 
          className="text-muted lh-lg"
          dangerouslySetInnerHTML={{ __html: profile.about }} 
        />
      </section>

      <section>
        <h2 className="h5 fw-bold text-dark mb-4">Professional Details</h2>
        <ul className="list-unstyled d-flex flex-column gap-3">
          <li><strong className="text-dark d-block">Experience Level:</strong> <span className="text-muted">{profile.experience}</span></li>
          <li><strong className="text-dark d-block">Languages:</strong> <span className="text-muted">{profile.languages.join(', ')}</span></li>
          <li><strong className="text-dark d-block">Specialties:</strong> <span className="text-muted">{profile.specialties.join(', ')}</span></li>
          {profile.certifications.length > 0 && (
              <li><strong className="text-dark d-block">Certifications:</strong> 
                  <ul className="text-muted ps-3 mt-1 mb-0">
                      {profile.certifications.map((cert, idx) => <li key={idx}>{cert}</li>)}
                  </ul>
              </li>
          )}
        </ul>
      </section>
    </div>
  );
};

export default AboutTab;
